export default __webpack_public_path__ + "static/media/mining-pass.25aa3b6a.png";